export const BRAND = {
  name: "Amlou",
  fullName: "Amlou Construcciones y Reformas S.L.",
  tagline: "Construimos tus ideas en realidad",
  subtagline: "Tu proyecto, nuestra prioridad",
  location: "Cunit, Tarragona",
  phonePrimary: "684 722 991",
  phoneSecondary: "677 698 411",
  phonePrimaryHref: "tel:+34684722991",
  phoneSecondaryHref: "tel:+34677698411",
  email: "info@construccionesamlou.com",
  emailHref: "mailto:info@construccionesamlou.com",
  whatsappUrl:
    "https://wa.me/34684722991?text=Hola%20Amlou%20Construcciones%2C%20quisiera%20solicitar%20un%20presupuesto%20sin%20compromiso.",
  year: new Date().getFullYear(),
};

export const NAV_LINKS = [
  { id: "inicio", label: "Inicio" },
  { id: "servicios", label: "Servicios" },
  { id: "ventajas", label: "Ventajas" },
  { id: "nosotros", label: "Nosotros" },
  { id: "proyectos", label: "Proyectos" },
  { id: "testimonios", label: "Testimonios" },
  { id: "contacto", label: "Contacto" },
];
